<template>
    <div>
        sss
    </div>
</template>
<script>
export default {
  name: 'Teste',
  mounted(){
      console.log(this.$vs.loading())
      console.log(this.$vs.loading())
      this.$vs.loading.close()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Teste.vue